export const API_KEY = "0eb252d7d359eee88c81ed569ed61993";
export const BASE_URL = "https://api.themoviedb.org/3";
export const IMAGE_URL = "https://image.tmdb.org/t/p/original";
